import { render } from "./SelecionarSimNao.vue?vue&type=template&id=38ad4e97&ts=true"
import script from "./SelecionarSimNao.vue?vue&type=script&lang=ts"
export * from "./SelecionarSimNao.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__